import { useEffect } from 'react';

interface SEOSchemaProps {
  type?: 'website' | 'webApplication';
  name?: string;
  description?: string;
  url?: string;
  imageUrl?: string;
}

const SEOSchema = ({ 
  type = 'webApplication',
  name = "Show Up! - Habit Tracker",
  description = "Don't overthink it. Show up again. The minimalist habit tracker that comes before habits & goals.",
  url = typeof window !== 'undefined' ? `https://showupagain.com${window.location.pathname}` : "https://showupagain.com/landing-page",
  imageUrl = "https://showupagain.com/lovable-uploads/9b33affd-d213-4c54-b7d2-a74e48fe5ff5.png"
}: SEOSchemaProps) => {
  useEffect(() => {
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }

    const schemaData = {
      "@context": "https://schema.org",
      "@type": type === 'webApplication' ? "WebApplication" : "WebSite",
      "name": name,
      "description": description,
      "url": url,
      "image": {
        "@type": "ImageObject",
        "url": imageUrl,
        "width": 1200,
        "height": 630,
        "alt": "Show Up! - Don't Overthink Habit Tracker Logo"
      },
      "applicationCategory": "HealthApplication",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "creator": {
        "@type": "Organization",
        "name": "Show Up!",
        "url": url,
        "logo": {
          "@type": "ImageObject",
          "url": imageUrl
        }
      },
      "keywords": [
        "PACT habit tracker",
        "don't overthink habits app", 
        "minimalist commitment tracker",
        "show up again motivation",
        "simple habit building app",
        "habit tracker before goals",
        "minimalist habit tracker",
        "PACT framework habits",
        "daily commitment app",
        "overthinking habits solution",
        "habit building minimalist",
        "commitment tracker app"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "67",
        "bestRating": "5",
        "worstRating": "1"
      },
      "featureList": [
        "PACT Framework Implementation",
        "Minimalist Habit Tracking",
        "Daily Commitment Tracking",
        "Progress Visualization",
        "Early Access Beta Program"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.querySelector('script[type="application/ld+json"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, [type, name, description, url, imageUrl]);

  return null;
};

export default SEOSchema;